var map = {
	".": 8305,
	"./": 8305,
	"./About": 3445,
	"./About.js": 3445,
	"./App": 9555,
	"./App.js": 9555,
	"./Articles": 8347,
	"./Articles.js": 8347,
	"./ArticlesDetails": 7112,
	"./ArticlesDetails.js": 7112,
	"./BlogDetails": 5127,
	"./BlogDetails.js": 5127,
	"./Blogs": 7401,
	"./Blogs.js": 7401,
	"./Footer": 705,
	"./Footer.js": 705,
	"./Home": 4492,
	"./Home.js": 4492,
	"./Navbar": 273,
	"./Navbar.js": 273,
	"./NotFound": 7919,
	"./NotFound.js": 7919,
	"./data/about": 4657,
	"./data/about.json": 4657,
	"./data/articles": 9802,
	"./data/articles.json": 9802,
	"./data/blogs": 4349,
	"./data/blogs.json": 4349,
	"./data/footer": 3145,
	"./data/footer.json": 3145,
	"./data/home": 5993,
	"./data/home.json": 5993,
	"./img/articles/articles-1/article_bg.png": 7051,
	"./img/articles/articles-1/article_cover.jpg": 7350,
	"./img/articles/articles-1/article_preview_1.jpg": 4900,
	"./img/articles/articles-1/article_preview_2.jpg": 4559,
	"./img/articles/articles-1/article_sticker.jpg": 6277,
	"./img/articles/articles-2/article_bg.png": 5221,
	"./img/articles/articles-2/article_bgdds.png": 4763,
	"./img/articles/articles-2/article_cover.jpg": 1699,
	"./img/articles/articles-2/article_preview_1.jpg": 3775,
	"./img/articles/articles-2/article_preview_2.jpg": 5761,
	"./img/articles/articles-2/article_preview_3.jpg": 4573,
	"./img/articles/articles-2/article_sticker.png": 1475,
	"./img/articles/coming_soon.png": 2095,
	"./img/blogs/blog-1/blog_cover.jpg": 9553,
	"./img/blogs/blog-1/blog_img_1.png": 2138,
	"./img/blogs/blog-1/blog_img_2.jpg": 1434,
	"./img/blogs/blog-1/blog_img_3.png": 538,
	"./img/home/home_preview_1.jpg": 4366,
	"./img/home/home_preview_2.jpg": 1548,
	"./img/home/home_preview_3.jpg": 1573,
	"./img/home/home_preview_4.jpg": 998,
	"./img/icons/arrow.svg": 6781,
	"./img/icons/cart.svg": 6429,
	"./img/icons/close.svg": 4837,
	"./img/icons/ham.svg": 1964,
	"./img/icons/satsune.svg": 4704,
	"./img/logo.png": 1053,
	"./img/logo.svg": 7582,
	"./index": 8305,
	"./index.js": 8305,
	"./reportWebVitals": 4013,
	"./reportWebVitals.js": 4013,
	"./sass/abstracts/_animations.scss": 8764,
	"./sass/abstracts/_breakpoints.scss": 3025,
	"./sass/abstracts/_colors.scss": 707,
	"./sass/abstracts/_index.scss": 1626,
	"./sass/abstracts/_mixins.scss": 1225,
	"./sass/abstracts/_sizes.scss": 1047,
	"./sass/abstracts/_tokens.scss": 1505,
	"./sass/abstracts/_typography.scss": 364,
	"./sass/base/_general.scss": 1916,
	"./sass/base/_index.scss": 7988,
	"./sass/base/_reset.scss": 5414,
	"./sass/base/_root.scss": 680,
	"./sass/components/_button.scss": 1212,
	"./sass/components/_index.scss": 4683,
	"./sass/components/_line-accessory.scss": 5071,
	"./sass/components/_loading.scss": 886,
	"./sass/components/_price.scss": 2166,
	"./sass/components/_site-footer.scss": 7673,
	"./sass/components/_site-header.scss": 2451,
	"./sass/components/_size-stock.scss": 6253,
	"./sass/layout/_container.scss": 371,
	"./sass/layout/_index.scss": 1325,
	"./sass/main.scss": 1076,
	"./sass/pages/_about.scss": 9348,
	"./sass/pages/_articles-details.scss": 1149,
	"./sass/pages/_articles.scss": 355,
	"./sass/pages/_blogs.scss": 5138,
	"./sass/pages/_home.scss": 2148,
	"./sass/pages/_index.scss": 5949,
	"./sass/pages/blogs-details.scss": 5094,
	"./sass/utilities/_box-shadow.scss": 9375,
	"./sass/utilities/_capitalize.scss": 8852,
	"./sass/utilities/_colors.scss": 8340,
	"./sass/utilities/_flow.scss": 4326,
	"./sass/utilities/_font-sizes.scss": 4776,
	"./sass/utilities/_font-weight.scss": 1710,
	"./sass/utilities/_image-sizes.scss": 8285,
	"./sass/utilities/_index.scss": 5967,
	"./sass/utilities/_mx-auto.scss": 2186,
	"./sass/utilities/_relative.scss": 7044,
	"./sass/utilities/_spacing.scss": 8374,
	"./sass/utilities/_text-align.scss": 3469,
	"./sass/utilities/_uppercase.scss": 4684,
	"./sass/vendors/_index.scss": 928,
	"./sass/vendors/_swiper-nav.scss": 7239,
	"./setupTests": 9511,
	"./setupTests.js": 9511,
	"./useOutsideClick": 4214,
	"./useOutsideClick.js": 4214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;